import { t } from "@/i18n-js/instance";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import { DefaultFullPreview } from "../../";
import { CheckoutFormSection } from "../../../../CheckoutFormSection";
import { DEFAULT_FULL_PREVIEW_VARIANT } from "../../constants";
import { PreviewBadge } from "./PreviewBadge";

export interface TotalDueTodayPreviewProps {
  preview: PaywallCheckoutPreview;
  variant?: keyof typeof DEFAULT_FULL_PREVIEW_VARIANT;
}

export const TotalDueTodayPreview = ({
  preview,
  variant = DEFAULT_FULL_PREVIEW_VARIANT.default,
}: TotalDueTodayPreviewProps) => (
  <CheckoutFormSection className="gap-y-3 border-t py-8">
    <DefaultFullPreview.PreviewEntry
      label={
        <>
          {t("paywall_checkout.amount_due")}
          {variant === DEFAULT_FULL_PREVIEW_VARIANT.default && (
            <PreviewBadge preview={preview} />
          )}
        </>
      }
      labelClassName="flex flex-row gap-x-2"
      labelSize="md"
      labelWeight="semibold"
      value={preview.formatted_amount_due_now}
      valueSize="lg"
      valueWeight="semibold"
      dataTestId="checkout-form-preview-total-due-today"
    />
  </CheckoutFormSection>
);
